import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import Icon from 'components/UI/Icon';
import { useStateModal } from 'utils/hooks';
import { useTrans } from 'utils/localisation';
import { pushCustomEvent } from 'utils/analytics';

import * as styles from './Filters.module.scss';

const FiltersModal = lazy(() => import('./components/FiltersModal'));

export default function Filters({
  className,
  projects,
  flags,
  defaultFilters,
  activeFilters,
  filters,
  setFilters,
}) {
  const t = useTrans(['filters']);
  const { modalState, showModal, hideModal } = useStateModal();
  const withActiveFilters = Boolean(activeFilters);

  const handleClick = () => {
    showModal();
    pushCustomEvent('ndrsn_projects_filtration', { action: 'click_on_filtration_button' });
  };

  return (
    <div className={className}>
      <button
        className={cn(styles.button, withActiveFilters && styles.withActiveFilters)}
        onClick={handleClick}
      >
        <span className={styles.iconWrapper}>
          <Icon className={styles.icon} name="controls-alt" />
        </span>
        <span className={styles.buttonName}>{t('filters')}</span>
        <span className={styles.activeFilters}>{activeFilters}</span>
      </button>
      <Suspense fallback={null}>
        <FiltersModal
          isOpen={modalState.isOpen}
          closeModalCallback={hideModal}
          projects={projects}
          flags={flags}
          defaultFilters={defaultFilters}
          filters={filters}
          setFilters={setFilters}
        />
      </Suspense>
    </div>
  );
}
